import { whiteLabelContent } from "./content";
import { whiteLabelResources } from "./resources";
import { applyWhiteLabelTheme, whiteLabelTheme } from "./theme";

const whiteLabelBundle = {
  config: {
    ...whiteLabelContent,
    theme: whiteLabelTheme,
  },
  resources: whiteLabelResources,
  applyTheme: applyWhiteLabelTheme,
  getWhatsAppUrl() {
    return `https://wa.me/${whiteLabelContent.contact.whatsappNumber}`;
  },
  isImageLogoPath(path?: string | null) {
    if (!path) return false;
    return /\.(png|webp|svg|jpg|jpeg|gif|avif)$/i.test(path.trim());
  },
} as const;

export { whiteLabelBundle };
export default whiteLabelBundle;
